module.exports = __webpack_public_path__ + "img/imgBabyCover.add890db.jpg";